import styled from "styled-components";
import { colorsPalettes } from "@similarweb/styles";

export const StyledWrapper = styled.div`
    align-items: center;
    background-color: ${colorsPalettes.bluegrey["100"]};
    box-sizing: border-box;
    display: flex;
    flex-flow: row nowrap;
    flex-shrink: 0;
    height: 56px;
    position: sticky;
    top: 0;
    z-index: 1;
`;
